import React from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Button, Fade, Modal,
} from '@mui/material';
import useStyles from './styles';
import NestedAccessoriesTable from './NestedAccessoriesTable';
import Loader from '../../../../commons/Loader';
import { treeStructureSettingsCustom } from '../../../../../utils/custom_prop_types/customPropTypes';

export default function NestedAccessoriesModal({
  modals,
  setOpenModal,
  handleAddAccessory,
  treeStructureSettings,
  setTreeStructureSettings,
}) {
  const classes = useStyles();

  const handleGoBack = () => {
    if (treeStructureSettings.level > 1) {
      setTreeStructureSettings(
        treeStructureSettings.level - 1,
        treeStructureSettings.parentId,
        treeStructureSettings.parentName,
      );
    }
  };

  const handleCloseModal = () => {
    setOpenModal('nestedAccessories', false);
    setTreeStructureSettings(0, null);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modals.nestedAccessories || false}
        closeAfterTransition
      >
        <Fade in={modals.nestedAccessories}>
          <div className={classes.paper}>
            <div className={classes.modalWrapper}>
              <div className={classes.headerWrapper}>
                <div className={classes.titleWrapper}>
                  <h2 id="transition-modal-title">
                    {treeStructureSettings.parentName?.[treeStructureSettings.level - 1]}
                  </h2>
                </div>
                { treeStructureSettings.level > 1 && (
                <Button
                  className={classes.buttonClose}
                  variant="contained"
                  color="secondary"
                  onClick={handleGoBack}
                >
                  <ArrowBackIcon />
                </Button>
                )}
                <Button
                  className={classes.buttonClose}
                  variant="contained"
                  color="secondary"
                  onClick={handleCloseModal}
                >
                  X
                </Button>
              </div>
              <Loader target="nestedAccessories" size={32} flex flexCentered>
                <NestedAccessoriesTable
                  handleAddAccessory={handleAddAccessory}
                />
              </Loader>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}

NestedAccessoriesModal.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  handleAddAccessory: PropTypes.func.isRequired,
  treeStructureSettings: treeStructureSettingsCustom.isRequired,
  setTreeStructureSettings: PropTypes.func.isRequired,
};
